import primaryLogo from 'assets/img/primaryLogo.png';
import React from 'react';
import styled from '@emotion/styled';

const BackDoorPageWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-flow: column;
	padding: 20px;

	h1 {
		font-size: 28;
		margin-bottom: 16px;
	}
	img {
		margin-bottom: 30px;
	}
`;

const BackDoorHome: React.FC = () => {
	return (
		<BackDoorPageWrapper>
			<img src={primaryLogo} alt="The main logo of MLB" />

			<h1>
				Welcome to the BEAT THE STREAK
			</h1>
			<p>
				You need to be logged in to view this game
			</p>
		</BackDoorPageWrapper>
	);
};

export default BackDoorHome;
